import React from "react";
import { LegalModal } from "./LegalModal";
import { LANDING } from "../constants/testIds/landing";
import { Landmark } from "lucide-react";

export const Impressum = ({ isOpen, onClose }) => {
  return (
    <LegalModal
      isOpen={isOpen}
      onClose={onClose}
      title="Impressum"
      icon={Landmark}
      testId={LANDING.impressumModal}
      closeTestId={LANDING.impressumCloseBtn}
    >
      {/* Verantwortlich */}
      <div className="space-y-2">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          Für den Inhalt verantwortlich
        </h4>
        <p className="text-xs text-[#b58e70] uppercase tracking-wider">Medieninhaber & Herausgeber</p>
        <p className="font-semibold text-[#1c110e]">Dipl.-Ing. Walter Unterberger</p>
        <p>1090 Wien</p>
        <p>Tel.: +43 676 569 4291</p>
        <p>Österreich</p>
      </div>

      {/* Kontakt */}
      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          Kontakt
        </h4>
        <p>
          E-Mail:{" "}
          <a href="mailto:office@entreamigos.at" className="text-[#8a2424] hover:underline">
            office@entreamigos.at
          </a>
        </p>
        <p>Telefon: +43 676 569 4291</p>
      </div>

      {/* Unternehmensdaten */}
      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          Unternehmensdaten
        </h4>
        <p>
          <span className="font-medium text-[#1c110e]">Unternehmensgegenstand:</span> Erteilung von
          Tanzunterricht (Tango Argentino)
        </p>
        <p>
          <span className="font-medium text-[#1c110e]">Mitgliedschaften:</span> Mitglied der
          Wirtschaftskammer Wien
        </p>
        <p>
          <span className="font-medium text-[#1c110e]">Zuständige Aufsichtsbehörde:</span>{" "}
          Magistratisches Bezirksamt für den 9. Bezirk
        </p>
        <p>
          <span className="font-medium text-[#1c110e]">Anwendbare Rechtsvorschriften:</span>{" "}
          Gewerbeordnung (GewO) – abrufbar unter{" "}
          <a
            href="https://www.ris.bka.gv.at"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#8a2424] hover:underline"
          >
            www.ris.bka.gv.at
          </a>
        </p>
      </div>

      {/* Online-Streitbeilegung */}
      <div className="space-y-2 pt-4 border-t border-[#b58e70]/20">
        <h4 className="font-serif text-base text-[#1c110e] font-medium uppercase tracking-wider text-[#d97036]">
          Online-Streitbeilegung
        </h4>
        <p>
          Verbraucher haben die Möglichkeit, Beschwerden an die Online-Streitbeilegungsplattform der
          EU zu richten:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#8a2424] hover:underline"
          >
            europa.eu
          </a>
          . Sie können allfällige Beschwerden auch an die oben angegebene E-Mail-Adresse richten.
        </p>
      </div>
    </LegalModal>
  );
};
